// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__8BKej","breadcrumb":"Breadcrumbs_breadcrumb__buzAC","breadcrumbIcon":"Breadcrumbs_breadcrumbIcon__JoFTp"};